import React from 'react';
import { X, Download } from 'lucide-react';

const ExportModal = ({
  exportColumns,
  allColumns,
  onToggleColumn,
  onSelectAll,
  onDeselectAll,
  onConfirm,
  onCancel,
  entriesCount,
  isLoading
}) => {
  const selectedCount = Object.values(exportColumns).filter(Boolean).length;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[100]">
      <div className="bg-slate-800 border border-slate-700 rounded-lg shadow-lg p-6 w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-semibold text-slate-200">Export to CSV</h3>
          <button
            onClick={onCancel}
            className="text-slate-400 hover:text-slate-200"
          >
            <X className="h-6 w-6" />
          </button>
        </div>

        <div className="mb-4">
          <p className="text-slate-300 mb-2">
            Select which columns to include in your CSV export ({entriesCount} entries)
          </p>
          <p className="text-sm text-slate-400">
            {selectedCount} of {allColumns.length} columns selected
          </p>
        </div>

        {/* Select All / Deselect All buttons */}
        <div className="flex space-x-3 mb-4">
          <button
            onClick={onSelectAll}
            className="bg-blue-600 text-white px-4 py-2 rounded text-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Select All
          </button>
          <button
            onClick={onDeselectAll}
            className="bg-slate-600 text-slate-200 px-4 py-2 rounded text-sm hover:bg-slate-500 focus:outline-none focus:ring-2 focus:ring-slate-400"
          >
            Deselect All
          </button>
        </div>

        {/* Column selection grid */}
        <div className="mb-6 max-h-96 overflow-y-auto border border-slate-600 rounded-lg p-4">
          <div className="grid grid-cols-2 gap-2">
            {allColumns.map((column) => (
              <label key={column.id} className="flex items-center space-x-2 text-slate-300 p-2 hover:bg-slate-700 rounded">
                <input
                  type="checkbox"
                  checked={exportColumns[column.id] || false}
                  onChange={() => onToggleColumn(column.id)}
                  className="rounded text-blue-500 focus:ring-blue-500 bg-slate-600 border-slate-500"
                />
                <span className="text-sm">{column.label}</span>
                <span className="text-xs text-slate-400">({column.id})</span>
              </label>
            ))}
          </div>
        </div>

        {/* Action buttons */}
        <div className="flex justify-end space-x-3">
          <button
            onClick={onCancel}
            disabled={isLoading}
            className="bg-slate-700 text-slate-300 px-4 py-2 rounded hover:bg-slate-600 focus:outline-none focus:ring-2 focus:ring-slate-400 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={selectedCount === 0 || isLoading}
            className={`px-4 py-2 rounded focus:outline-none focus:ring-2 ${
              selectedCount === 0 || isLoading
                ? 'bg-slate-600 text-slate-400 cursor-not-allowed'
                : 'bg-green-600 text-white hover:bg-green-700 focus:ring-green-500'
            }`}
          >
            <div className="flex items-center space-x-2">
              {isLoading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                  <span>Exporting...</span>
                </>
              ) : (
                <>
                  <Download className="h-4 w-4" />
                  <span>Export CSV ({selectedCount} columns)</span>
                </>
              )}
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExportModal;
